module.exports = __webpack_public_path__ + "img/QLC.7413a7a6.svg";